import useLocaleText from 'components/useLocaleText'

// New literals required in the configured translation catalogue. Kept beside their UI owner
// so missing translations remain explicit; fallbacks use the actual locale, never layout direction.
export const missingExecutionLiterals = {
  uploadFiles: { key: 'tasks_execution_upload_files', fallback: { en: 'Upload files', he: 'העלאת קבצים' } },
  documentsAndVideos: {
    key: 'tasks_execution_documents_and_videos',
    fallback: { en: 'Documents and videos', he: 'מסמכים וסרטונים' },
  },
  sendComment: { key: 'tasks_execution_send_comment', fallback: { en: 'Send comment', he: 'שליחת תגובה' } },
  addAttachment: { key: 'tasks_execution_add_attachment', fallback: { en: 'Add attachment', he: 'הוספת קובץ מצורף' } },
  attachVideo: { key: 'task_creation_add_video', fallback: { en: 'Add video', he: 'הוספת וידאו' } },
  voiceInput: { key: 'tasks_execution_voice_input', fallback: { en: 'Start voice input', he: 'התחלת קלט קולי' } },
  stopAndInsert: { key: 'tasks_execution_stop_and_insert', fallback: { en: 'Stop and insert', he: 'עצירה והוספה' } },
  commentFailed: {
    key: 'tasks_execution_comment_failed',
    fallback: {
      en: 'Comment could not be sent. Your text and attachments are kept. Please retry.',
      he: 'שליחת התגובה נכשלה. הטקסט והקבצים נשמרו. נסו שוב.',
    },
  },
  microphoneDenied: {
    key: 'tasks_execution_microphone_denied',
    fallback: {
      en: 'Allow microphone access in your browser settings to use voice input.',
      he: 'אפשרו גישה למיקרופון בהגדרות הדפדפן כדי להשתמש בקלט קולי.',
    },
  },
  file: { key: 'tasks_execution_file', fallback: { en: 'File', he: 'קובץ' } },
  of: { key: 'tasks_execution_of', fallback: { en: 'of', he: 'מתוך' } },
  commentsOn: { key: 'tasks_execution_comments_on', fallback: { en: 'Comments on file', he: 'תגובות לקובץ' } },
  commentingOn: { key: 'tasks_execution_commenting_on', fallback: { en: 'Commenting on file', he: 'תגובה לקובץ' } },
  change: { key: 'tasks_execution_change', fallback: { en: 'Change', he: 'שינוי' } },
  allFiles: { key: 'tasks_execution_all_files', fallback: { en: 'All files', he: 'כל הקבצים' } },
  allSubtasks: { key: 'tasks_execution_all_subtasks', fallback: { en: 'All subtasks', he: 'כל תת־המשימות' } },
  upload: { key: 'tasks_execution_upload', fallback: { en: 'Upload', he: 'העלאה' } },
  uploadFromGallery: {
    key: 'tasks_execution_upload_from_gallery',
    fallback: { en: 'or upload from gallery', he: 'או העלאה מהגלריה' },
  },
  takePhoto: { key: 'tasks_execution_take_photo', fallback: { en: 'Take a photo', he: 'צילום תמונה' } },
  record: { key: 'tasks_execution_record', fallback: { en: 'Record a video', he: 'צילום וידאו' } },
  noPhoto: { key: 'tasks_execution_no_photo', fallback: { en: 'No photo yet', he: 'עדיין אין תמונה' } },
  noVideo: { key: 'tasks_execution_no_video', fallback: { en: 'No video yet', he: 'עדיין אין וידאו' } },
  uploadHint: {
    key: 'tasks_execution_upload_hint',
    fallback: { en: 'Capture or upload media to complete this subtask.', he: 'צלמו או העלו קובץ להשלמת תת־המשימה.' },
  },
  noMedia: { key: 'tasks_execution_no_media', fallback: { en: 'No media submitted yet', he: 'עדיין לא הוגשו קבצים' } },
  noComments: { key: 'tasks_execution_no_comments', fallback: { en: 'No comments yet', he: 'עדיין אין תגובות' } },
  commentsHint: {
    key: 'tasks_execution_comments_hint',
    fallback: { en: 'Comments always belong to the selected file.', he: 'התגובות תמיד שייכות לקובץ הנבחר.' },
  },
  selectHint: {
    key: 'tasks_execution_select_hint',
    fallback: { en: 'Upload a file to start the discussion.', he: 'העלו קובץ כדי להתחיל בדיון.' },
  },
  expand: { key: 'tasks_execution_expand', fallback: { en: 'Expand', he: 'הרחבה' } },
  collapse: { key: 'tasks_execution_collapse', fallback: { en: 'Collapse', he: 'צמצום' } },
  references: { key: 'task_creation_refs', fallback: { en: 'References', he: 'קבצי עזר' } },
  optional: { key: 'task_creation_optional', fallback: { en: 'Optional', he: 'רשות' } },
  subtask: { key: 'tasks_execution_subtask', fallback: { en: 'Subtask', he: 'תת־משימה' } },
  submitted: { key: 'tasks_execution_submitted', fallback: { en: 'Submitted', he: 'הוגש' } },
  awaitingReview: { key: 'tasks_execution_awaiting_review', fallback: { en: 'Awaiting review', he: 'ממתין לבדיקה' } },
  ai: { key: 'tasks_execution_ai', fallback: { en: 'AI analysis', he: 'ניתוח AI' } },
  aiSubtask: { key: 'tasks_execution_ai_subtask', fallback: { en: 'AI subtask', he: 'תת־משימת AI' } },
  score: { key: 'tasks_execution_score', fallback: { en: 'Score', he: 'ציון' } },
  aiLoading: {
    key: 'tasks_execution_ai_loading',
    fallback: { en: 'AI is analysing the media…', he: 'AI מנתח את הקובץ…' },
  },
  aiHint: {
    key: 'tasks_execution_ai_hint',
    fallback: { en: 'You can comment while the analysis runs.', he: 'אפשר להגיב בזמן הניתוח.' },
  },
  fullAnalysis: { key: 'tasks_execution_full_analysis', fallback: { en: 'Show full analysis', he: 'הצג ניתוח מלא' } },
  uploadFailed: { key: 'tasks_execution_upload_failed', fallback: { en: 'Upload failed', he: 'ההעלאה נכשלה' } },
  retry: { key: 'tasks_execution_retry', fallback: { en: 'Retry', he: 'ניסיון חוזר' } },
  remove: { key: 'tasks_execution_remove', fallback: { en: 'Remove', he: 'הסרה' } },
  uploadFailedHint: {
    key: 'tasks_execution_upload_failed_hint',
    fallback: {
      en: 'The file stays in the queue. Retry when the connection is back.',
      he: 'הקובץ נשאר בתור. נסו שוב כשהחיבור יחזור.',
    },
  },
  uploaded: { key: 'tasks_execution_uploaded', fallback: { en: 'files uploaded', he: 'קבצים הועלו' } },
  failed: { key: 'tasks_execution_failed', fallback: { en: 'files failed', he: 'קבצים נכשלו' } },
  saved: { key: 'tasks_execution_saved', fallback: { en: 'Saved automatically', he: 'נשמר אוטומטית' } },
  open: { key: 'tasks_execution_open', fallback: { en: 'Open', he: 'פתיחה' } },
  review: { key: 'tasks_execution_review', fallback: { en: 'Review', he: 'בדיקה' } },
  noMediaYet: { key: 'tasks_execution_no_media_yet', fallback: { en: 'No media yet', he: 'אין קבצים' } },
  download: { key: 'tasks_execution_download', fallback: { en: 'Download', he: 'הורדה' } },
  downloading: { key: 'tasks_execution_downloading', fallback: { en: 'Downloading…', he: 'מוריד…' } },
  downloadFailed: {
    key: 'tasks_execution_download_failed',
    fallback: { en: 'Could not download the file. Please retry.', he: 'הורדת הקובץ נכשלה. נסו שוב.' },
  },
  delete: { key: 'tasks_execution_delete', fallback: { en: 'Delete file', he: 'מחיקת קובץ' } },
  fullscreen: { key: 'tasks_execution_fullscreen', fallback: { en: 'Full screen', he: 'מסך מלא' } },
  previous: { key: 'tasks_execution_previous', fallback: { en: 'Previous file', he: 'הקובץ הקודם' } },
  next: { key: 'tasks_execution_next', fallback: { en: 'Next file', he: 'הקובץ הבא' } },
  commentOnMedia: {
    key: 'tasks_execution_comment_on_media',
    fallback: { en: 'Annotate and comment', he: 'סימון ותגובה' },
  },
  replyHint: {
    key: 'tasks_execution_reply_hint',
    fallback: { en: 'Write your reply below', he: 'כתבו את התשובה שלכם כאן למטה' },
  },
  writeReply: { key: 'tasks_execution_write_reply', fallback: { en: 'Write a reply…', he: 'כתבו תשובה…' } },
  sendReply: { key: 'tasks_execution_send_reply', fallback: { en: 'Send reply', he: 'שליחת תשובה' } },
  cancelReply: { key: 'tasks_execution_cancel_reply', fallback: { en: 'Cancel reply', he: 'ביטול תשובה' } },
  due: { key: 'tasks_execution_due', fallback: { en: 'Due', he: 'מועד' } },
  executor: { key: 'tasks_execution_executor', fallback: { en: 'Executor', he: 'מבצע' } },
  remaining: {
    key: 'tasks_execution_remaining',
    fallback: { en: 'subtasks still required', he: 'תת־משימות חובה נותרו' },
  },
  saveFailed: {
    key: 'tasks_execution_save_failed',
    fallback: { en: 'Could not save the result. Please retry.', he: 'שמירת התוצאה נכשלה. נסו שוב.' },
  },
  aiFailed: {
    key: 'tasks_execution_ai_failed',
    fallback: { en: 'AI analysis failed. Your media is saved.', he: 'ניתוח AI נכשל. הקובץ נשמר.' },
  },
  retryAnalysis: { key: 'tasks_execution_retry_analysis', fallback: { en: 'Retry analysis', he: 'ניתוח חוזר' } },
  previousSubtask: {
    key: 'tasks_execution_previous_subtask',
    fallback: { en: 'Previous subtask', he: 'תת־המשימה הקודמת' },
  },
  nextSubtask: { key: 'tasks_execution_next_subtask', fallback: { en: 'Next subtask', he: 'תת־המשימה הבאה' } },
} as const

export const executionLiterals = {
  replyTo: { key: 'reply_to_title', fallback: { en: 'Replying to', he: 'תגובה ל־' } },
  attachImage: { key: 'post_attach_photo_web_hover', fallback: { en: 'Add photo', he: 'הוספת תמונה' } },
  writeComment: { key: 'write_a_comment', fallback: { en: 'Write a comment…', he: 'כתבו תגובה…' } },
  attachFile: { key: 'upload_file_btn', fallback: { en: 'Add file', he: 'הוספת קובץ' } },
  files: { key: 'subtask_files', fallback: { en: 'files', he: 'קבצים' } },
  comments: { key: 'subtask_comments', fallback: { en: 'comments', he: 'תגובות' } },
  add: { key: 'add', fallback: { en: 'Add', he: 'הוספה' } },
  more: { key: 'see_more', fallback: { en: 'Show more', he: 'הצג עוד' } },
  less: { key: 'show_less', fallback: { en: 'Show less', he: 'הצג פחות' } },
  photo: { key: 'photo', fallback: { en: 'Photo', he: 'תמונה' } },
  video: { key: 'video', fallback: { en: 'Video', he: 'וידאו' } },
  required: { key: 'required', fallback: { en: 'Required', he: 'חובה' } },
  notStarted: { key: 'task_status_todo', fallback: { en: 'Not started', he: 'טרם התחיל' } },
  inProgress: { key: 'task_status_inprogress', fallback: { en: 'In progress', he: 'בתהליך' } },
  done: { key: 'done', fallback: { en: 'Done', he: 'בוצע' } },
  approved: { key: 'task_status_approved', fallback: { en: 'Approved', he: 'אושר' } },
  rejected: { key: 'task_status_rejected', fallback: { en: 'Rejected', he: 'נדחה' } },
  skipped: { key: 'task_status_skipped', fallback: { en: 'Skipped', he: 'דולג' } },
  aiReviewed: { key: 'task_status_reviewed_ai', fallback: { en: 'Reviewed by AI', he: 'נבדק על ידי AI' } },
  cancel: { key: 'cancel', fallback: { en: 'Cancel', he: 'ביטול' } },
  uploading: { key: 'uploading_post_media_loading', fallback: { en: 'Uploading', he: 'מעלה' } },
  rating: { key: 'rating', fallback: { en: 'Rating', he: 'דירוג' } },
  approve: { key: 'approve', fallback: { en: 'Approve', he: 'אישור' } },
  reject: { key: 'reject', fallback: { en: 'Reject', he: 'דחייה' } },
  approveWithReservation: {
    key: 'approve_with_reservation',
    fallback: { en: 'Approve with reservation', he: 'אישור עם הסתייגות' },
  },
  close: { key: 'close', fallback: { en: 'Close', he: 'סגירה' } },
  high: { key: 'high', fallback: { en: 'High', he: 'גבוה' } },
  back: { key: 'header_button_back', fallback: { en: 'Back', he: 'חזרה' } },
  ...missingExecutionLiterals,
} as const

export const useExecutionText = () => useLocaleText(executionLiterals)
